import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.jsx'
import { AppUpdate } from '@app-update'

// Override window.alert to dispatch a custom event and return a Promise
window.alert = (message) => {
  return new Promise((resolve) => {
    window.dispatchEvent(new CustomEvent('show-alert-modal', {
      detail: { message: message !== undefined ? String(message) : '', resolve }
    }));
  });
};

// Override window.confirm to dispatch a custom event and return a Promise
window.confirm = (message) => {
  return new Promise((resolve) => {
    window.dispatchEvent(new CustomEvent('show-confirm-modal', {
      detail: { message: message !== undefined ? String(message) : '', resolve }
    }));
  });
};

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <AppUpdate />
    <App />
  </StrictMode>,
)
